// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React, { useState, useEffect } from 'react';
import { FormControl, FormGroup } from 'react-bootstrap';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import styled from 'styled-components';
import Modal from '../utils/ModalComponet';

const StyledDeleteButton = styled.button`
  position: absolute;
  left: 25px;
  bottom: 25px;
`;

const getInitialForm = reviewToResponse =>
  reviewToResponse?.adminResponse?.text || '';

const ReviewResponseModal = ({
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  isOpen,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  closeModal,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  onSave,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  reviewToResponse,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  onResponseDelete,
}) => {
  const [response, setResponse] = useState(getInitialForm(reviewToResponse));

  const onChange = event => {
    setResponse(event.target.value);
  };

  const onResponseSave = event => {
    event.preventDefault();
    onSave(response, reviewToResponse);
  };

  useEffect(() => {
    setResponse(getInitialForm(reviewToResponse));
  }, reviewToResponse);

  return (
    <Modal
      open={isOpen}
      closeModal={closeModal}
      cancel={closeModal}
      action={onResponseSave}
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/prop-types
      actionButtonText={reviewToResponse.adminResponse ? 'Update' : 'Create'}
    >
      <h4>Review Response</h4>
      <FormGroup controlId='body'>
        <FormControl
          value={response}
          componentClass='textarea'
          onChange={onChange}
        />
      </FormGroup>
      {/* TODO: Fix this the next time the file is edited. */}
      {/* eslint-disable-next-line react/prop-types */}
      {reviewToResponse.adminResponse && (
        <StyledDeleteButton
          className='btn btn-danger'
          onClick={() => onResponseDelete(reviewToResponse)}
        >
          Delete
        </StyledDeleteButton>
      )}
    </Modal>
  );
};

export default ReviewResponseModal;
